// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#nav-bar {
    display: flex;
    justify-content: space-between;

    height: 90px;
    min-height: auto;
}

.fixed{
    width: 75%;
    margin: 0;
    position: fixed;

    padding: 0 12.5%;
    z-index: 999;
    border-bottom: 2px solid rgb(0,0,0,0.3);

}

.home{
    background-color: rgb(255,255,255, 0.82);
}
.product{
    background-color: #01483F;
}
.service{
    background-color: #05824a;
}

.contact{
    background-color: #01483F;
}

.relative{
    width: 75%;
    position: absolute;
    top: 50px;
    margin-left: 12.5%;
    margin-right: 12.5%;
    background-color: transparent;
    z-index: 2;
}

#nav-bar-icon {
    width: 60px;
    height: 60px;
    margin: 0 5px;
}

#nav-bar-title-container {
    width: 30%;
    display: flex;
    justify-content: flex-start;
    align-items: center;

    color: white;
}

#nav-bar-menu-container {
    width: 70%;
    display: flex;
    justify-content: flex-end;

}

#nav-bar-select-container {
    height: 100%;
    width: 7%;

    display: flex;
    justify-content: center;
    align-items: center;
}


.nav-bar-select {
    width: 100%;
    height: 40%;
    display: flex;
    align-items: center;
    font-size: 1em;
    outline: none;
    background-color: transparent;
}

.nav-bar-select-transparent {
    color: #012D26;
    border: 2px solid #012D26;
}

.nav-bar-select-color {
    color: #F5F5F5;
    border: 2px solid #F5F5F5;
}

.nav-menu {
    width: 22%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1.1em;
}

.nav-menu:hover {
    cursor: pointer;
}

a {
    text-decoration: none;
}

.option-color-bg {
    background-color: #012D26;
    color: #F5F5F5;
}

#mobile-navigation-icon {
    width: 45px;
    height: 50px;
}

@media only screen and (max-width: 1100px) {
    #nav-bar {
        position: relative;
        z-index: 11;

        width: 100%;
        height: 70px;

        display: flex;
        align-items: center;
        font-size: 1.8em;
        font-weight: bold;
        color: #012D26;

        box-shadow: 0 1px 3px 1px rgba(98, 98, 98, 0.75);
        background-color: white;

        margin: 0;
        padding: 0;
    }

    #nav-bar-title-container {
        width: 90%;
        height: 70px;
        margin: 0 0 0 40px;

        color: #012D26;
        display: flex;
    }

    #nav-bar-title{
        margin-left: 2%;
    }

    #nav-bar-icon {
        width: 45px;
        height: 45px;
    }

    #nav-bar-hamburger {
        width: 10%;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #01483F;
    }

    #mobile-nav-menu{
        position: absolute;
        width: 100%;
        height: 100vh;
        z-index: 12;
        overflow: hidden;
    }

    #bg{
        width: 70%;
        background-color: rgba(0,0,0,0.30);
    }

    #mobile-nav-menu-container{
        color: #ffffff;
        background-color: #05824a;
        position: relative;
        z-index: 13;
        width: 50%;
        height: 100vh;
    }

    #menu-icon{
        width: 65px;
        height: 65px;
    }

    #menu-title{
        width: 100%;
        margin-top: 20px;
        font-size: 1.8em;
    }

    .mobile-menu{
        font-size: 0.8em;
        color: #ffffff;
        height: 50px;
        display: flex;
        align-items: center;
        margin-left: 20px;
    }

    .nav-bar-select{
        width: 75px;
        height: 40px;
    }

    .hide{
        display: none;
        right: -20000px;
    }

    .show{
        display: flex;
        justify-content: flex-end;
        right: 0;
    }
}

@media screen and (max-width: 600px) {
    #nav-bar-title-container{
        margin-left: 1%;
    }

    #nav-bar-title{
        font-size: 0.8em;
    }

    #nav-bar-icon {
        width: 30px;
        height: 30px;
    }
    #mobile-nav-menu-container{
        width: 70%;
    }

    #menu-icon{
        width: 40px;
        height: 40px;
    }

    #menu-title{
        font-size: 1em;
    }
    .nav-bar-select{
        width: 50px;
        height: 30px;
        font-size: 0.8em;
    }
    .mobile-menu{
        font-size: 0.8em;
    }

    #menu-icon{
        width: 35px;
        height: 35px;
    }
}

@media screen and (max-width: 400px) {
    #nav-bar-title{
        font-size: 0.5em;
    }
}`, "",{"version":3,"sources":["webpack://./src/App/Component/NavigationBar/style.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,8BAA8B;;IAE9B,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,SAAS;IACT,eAAe;;IAEf,gBAAgB;IAChB,YAAY;IACZ,uCAAuC;;AAE3C;;AAEA;IACI,wCAAwC;AAC5C;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,UAAU;IACV,kBAAkB;IAClB,SAAS;IACT,kBAAkB;IAClB,mBAAmB;IACnB,6BAA6B;IAC7B,UAAU;AACd;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,UAAU;IACV,aAAa;IACb,2BAA2B;IAC3B,mBAAmB;;IAEnB,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,aAAa;IACb,yBAAyB;;AAE7B;;AAEA;IACI,YAAY;IACZ,SAAS;;IAET,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;;AAGA;IACI,WAAW;IACX,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,cAAc;IACd,aAAa;IACb,6BAA6B;AACjC;;AAEA;IACI,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,UAAU;IACV,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI;QACI,kBAAkB;QAClB,WAAW;;QAEX,WAAW;QACX,YAAY;;QAEZ,aAAa;QACb,mBAAmB;QACnB,gBAAgB;QAChB,iBAAiB;QACjB,cAAc;;QAEd,gDAAgD;QAChD,uBAAuB;;QAEvB,SAAS;QACT,UAAU;IACd;;IAEA;QACI,UAAU;QACV,YAAY;QACZ,kBAAkB;;QAElB,cAAc;QACd,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,UAAU;QACV,aAAa;QACb,uBAAuB;QACvB,mBAAmB;QACnB,cAAc;IAClB;;IAEA;QACI,kBAAkB;QAClB,WAAW;QACX,aAAa;QACb,WAAW;QACX,gBAAgB;IACpB;;IAEA;QACI,UAAU;QACV,kCAAkC;IACtC;;IAEA;QACI,cAAc;QACd,yBAAyB;QACzB,kBAAkB;QAClB,WAAW;QACX,UAAU;QACV,aAAa;IACjB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,gBAAgB;QAChB,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;QAChB,cAAc;QACd,YAAY;QACZ,aAAa;QACb,mBAAmB;QACnB,iBAAiB;IACrB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,aAAa;QACb,eAAe;IACnB;;IAEA;QACI,aAAa;QACb,yBAAyB;QACzB,QAAQ;IACZ;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;IACA;QACI,UAAU;IACd;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,cAAc;IAClB;IACA;QACI,WAAW;QACX,YAAY;QACZ,gBAAgB;IACpB;IACA;QACI,gBAAgB;IACpB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ","sourcesContent":["#nav-bar {\r\n    display: flex;\r\n    justify-content: space-between;\r\n\r\n    height: 90px;\r\n    min-height: auto;\r\n}\r\n\r\n.fixed{\r\n    width: 75%;\r\n    margin: 0;\r\n    position: fixed;\r\n\r\n    padding: 0 12.5%;\r\n    z-index: 999;\r\n    border-bottom: 2px solid rgb(0,0,0,0.3);\r\n\r\n}\r\n\r\n.home{\r\n    background-color: rgb(255,255,255, 0.82);\r\n}\r\n.product{\r\n    background-color: #01483F;\r\n}\r\n.service{\r\n    background-color: #05824a;\r\n}\r\n\r\n.contact{\r\n    background-color: #01483F;\r\n}\r\n\r\n.relative{\r\n    width: 75%;\r\n    position: absolute;\r\n    top: 50px;\r\n    margin-left: 12.5%;\r\n    margin-right: 12.5%;\r\n    background-color: transparent;\r\n    z-index: 2;\r\n}\r\n\r\n#nav-bar-icon {\r\n    width: 60px;\r\n    height: 60px;\r\n    margin: 0 5px;\r\n}\r\n\r\n#nav-bar-title-container {\r\n    width: 30%;\r\n    display: flex;\r\n    justify-content: flex-start;\r\n    align-items: center;\r\n\r\n    color: white;\r\n}\r\n\r\n#nav-bar-menu-container {\r\n    width: 70%;\r\n    display: flex;\r\n    justify-content: flex-end;\r\n\r\n}\r\n\r\n#nav-bar-select-container {\r\n    height: 100%;\r\n    width: 7%;\r\n\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\n\r\n\r\n.nav-bar-select {\r\n    width: 100%;\r\n    height: 40%;\r\n    display: flex;\r\n    align-items: center;\r\n    font-size: 1em;\r\n    outline: none;\r\n    background-color: transparent;\r\n}\r\n\r\n.nav-bar-select-transparent {\r\n    color: #012D26;\r\n    border: 2px solid #012D26;\r\n}\r\n\r\n.nav-bar-select-color {\r\n    color: #F5F5F5;\r\n    border: 2px solid #F5F5F5;\r\n}\r\n\r\n.nav-menu {\r\n    width: 22%;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    font-size: 1.1em;\r\n}\r\n\r\n.nav-menu:hover {\r\n    cursor: pointer;\r\n}\r\n\r\na {\r\n    text-decoration: none;\r\n}\r\n\r\n.option-color-bg {\r\n    background-color: #012D26;\r\n    color: #F5F5F5;\r\n}\r\n\r\n#mobile-navigation-icon {\r\n    width: 45px;\r\n    height: 50px;\r\n}\r\n\r\n@media only screen and (max-width: 1100px) {\r\n    #nav-bar {\r\n        position: relative;\r\n        z-index: 11;\r\n\r\n        width: 100%;\r\n        height: 70px;\r\n\r\n        display: flex;\r\n        align-items: center;\r\n        font-size: 1.8em;\r\n        font-weight: bold;\r\n        color: #012D26;\r\n\r\n        box-shadow: 0 1px 3px 1px rgba(98, 98, 98, 0.75);\r\n        background-color: white;\r\n\r\n        margin: 0;\r\n        padding: 0;\r\n    }\r\n\r\n    #nav-bar-title-container {\r\n        width: 90%;\r\n        height: 70px;\r\n        margin: 0 0 0 40px;\r\n\r\n        color: #012D26;\r\n        display: flex;\r\n    }\r\n\r\n    #nav-bar-title{\r\n        margin-left: 2%;\r\n    }\r\n\r\n    #nav-bar-icon {\r\n        width: 45px;\r\n        height: 45px;\r\n    }\r\n\r\n    #nav-bar-hamburger {\r\n        width: 10%;\r\n        display: flex;\r\n        justify-content: center;\r\n        align-items: center;\r\n        color: #01483F;\r\n    }\r\n\r\n    #mobile-nav-menu{\r\n        position: absolute;\r\n        width: 100%;\r\n        height: 100vh;\r\n        z-index: 12;\r\n        overflow: hidden;\r\n    }\r\n\r\n    #bg{\r\n        width: 70%;\r\n        background-color: rgba(0,0,0,0.30);\r\n    }\r\n\r\n    #mobile-nav-menu-container{\r\n        color: #ffffff;\r\n        background-color: #05824a;\r\n        position: relative;\r\n        z-index: 13;\r\n        width: 50%;\r\n        height: 100vh;\r\n    }\r\n\r\n    #menu-icon{\r\n        width: 65px;\r\n        height: 65px;\r\n    }\r\n\r\n    #menu-title{\r\n        width: 100%;\r\n        margin-top: 20px;\r\n        font-size: 1.8em;\r\n    }\r\n\r\n    .mobile-menu{\r\n        font-size: 0.8em;\r\n        color: #ffffff;\r\n        height: 50px;\r\n        display: flex;\r\n        align-items: center;\r\n        margin-left: 20px;\r\n    }\r\n\r\n    .nav-bar-select{\r\n        width: 75px;\r\n        height: 40px;\r\n    }\r\n\r\n    .hide{\r\n        display: none;\r\n        right: -20000px;\r\n    }\r\n\r\n    .show{\r\n        display: flex;\r\n        justify-content: flex-end;\r\n        right: 0;\r\n    }\r\n}\r\n\r\n@media screen and (max-width: 600px) {\r\n    #nav-bar-title-container{\r\n        margin-left: 1%;\r\n    }\r\n\r\n    #nav-bar-title{\r\n        font-size: 0.8em;\r\n    }\r\n\r\n    #nav-bar-icon {\r\n        width: 30px;\r\n        height: 30px;\r\n    }\r\n    #mobile-nav-menu-container{\r\n        width: 70%;\r\n    }\r\n\r\n    #menu-icon{\r\n        width: 40px;\r\n        height: 40px;\r\n    }\r\n\r\n    #menu-title{\r\n        font-size: 1em;\r\n    }\r\n    .nav-bar-select{\r\n        width: 50px;\r\n        height: 30px;\r\n        font-size: 0.8em;\r\n    }\r\n    .mobile-menu{\r\n        font-size: 0.8em;\r\n    }\r\n\r\n    #menu-icon{\r\n        width: 35px;\r\n        height: 35px;\r\n    }\r\n}\r\n\r\n@media screen and (max-width: 400px) {\r\n    #nav-bar-title{\r\n        font-size: 0.5em;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
